import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { Navbar } from "react-bootstrap";
import HamburgerIcon from "../../../Assets/Icons/hamburger.png";
import LogoIcon from "../../../Assets/Icons/ONLY RYAN FULL LOGO RED.png";
import { observer } from "mobx-react-lite";
import { portalStore } from "../../../Stores/portal";
import { useNavigate } from "react-router-dom";

import Controllers from "../../../Assets/Icons/game-controller.png";

export const _MainDrawer: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const nav = useNavigate();

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 350 }} role="presentation" onClick={toggleDrawer(false)}>
      <List style={{ marginTop: "50px" }}>
        <ListItem>
          <img src={LogoIcon} height={40} style={{ margin: "auto auto" }} />
        </ListItem>
        <ListItem key={"home"} disablePadding>
          <ListItemButton onClick={() => nav("/")}>
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary={"Home"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"Tournaments"} disablePadding>
          <ListItemButton onClick={() => nav("/tournaments")}>
            <ListItemIcon></ListItemIcon>
            <ListItemText primary={"Tournaments"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"players"} disablePadding>
          <ListItemButton onClick={() => nav("/players")}>
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary={"Players"} />
          </ListItemButton>
        </ListItem>
        {/* <ListItem key={"events"} disablePadding >
          <ListItemButton onClick={() => nav("/events")}>
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary={"Events"} />
          </ListItemButton>
        </ListItem> */}
        <ListItem key={"Controllers"} disablePadding>
          <ListItemButton onClick={() => nav("/controllers")}>
            <ListItemIcon></ListItemIcon>
            <ListItemText primary={"Controllers"} />
          </ListItemButton>
        </ListItem>
        <ListItem key={"Transactions"} disablePadding>
          <ListItemButton onClick={() => nav("/accounting")}>
            <ListItemIcon></ListItemIcon>
            <ListItemText primary={"Accounting"} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
    </Box>
  );

  return (
    <div>
      <Navbar.Text aria-controls="navbarScroll">
        <span
          onClick={() => setOpen(true)}
          style={{
            padding: "10px",
            marginRight: "10px",
            marginLeft: "10px",
            cursor: "pointer",
          }}
        >
          <img src={HamburgerIcon} height={30} />
        </span>
      </Navbar.Text>
      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        style={{ marginTop: "50px" }}
      >
        {DrawerList}
      </Drawer>
    </div>
  );
};

const MainDrawer = observer(_MainDrawer);
export default MainDrawer;
